export class PhoneFormatter {
  static format(phone: string | null | undefined): string {
    if (!phone) return '';
    
    // Remove all non-numeric characters
    const cleaned = phone.replace(/\D/g, '');
    
    // Format based on length
    if (cleaned.length === 10) {
      // Format: (XX) XXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (cleaned.length === 11) {
      // Format: (XX) XXXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (cleaned.length === 8) {
      // Format: XXXX-XXXX (for landlines without area code)
      return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else if (cleaned.length === 9) {
      // Format: XXXXX-XXXX (for mobile without area code)
      return cleaned.replace(/(\d{5})(\d{4})/, '$1-$2');
    }
    
    // If length doesn't match expected patterns, return as is
    return phone;
  }
}